module.exports = __webpack_public_path__ + "static/the-courage-to-be-disliked-efc5b64dadbf9aab816dbeb2863391c8.jpg";